import { render } from "./VisibilitySelect.vue?vue&type=template&id=05986ba2"
import script from "./VisibilitySelect.vue?vue&type=script&lang=js"
export * from "./VisibilitySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__